import React, { Fragment } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import StaffMember from "./staffMember/index";
import Dashboard from "./dashboard/index";
import Profile from "./memberProfile";
import Products from "./products";
import Brands from "./brands";
import Categories from "./categories";
import BannerImage from "./bannerImage";
import Clients from "./client";
import ClientEnquiries from "./clientEnquiries";
import ClientContactUs from "./clientContactUs";
import Invoice from "./invoice";
import Icons from "./icons";
import store from "store";
import "react-table/react-table.css";
const App = ({ match }) => (
  <Fragment>
    <Switch>
      {store.get("staffMember").accessLevel === 1 && (
        <Route path={`${match.url}staff-members`} component={StaffMember} />
      )}
      <Route path={`${match.url}dashboard`} component={Dashboard} />
      <Route path={`${match.url}products`} component={Products} />
      <Route path={`${match.url}brands`} component={Brands} />
      <Route path={`${match.url}banners`} component={BannerImage} />
      <Route path={`${match.url}categories`} component={Categories} />
      <Route path={`${match.url}clients`} component={Clients} />
      <Route path={`${match.url}enquiries`} component={ClientEnquiries} />
      <Route path={`${match.url}contact-us`} component={ClientContactUs} />
      <Route path={`${match.url}invoices`} component={Invoice} />
      <Route path={`${match.url}profile`} component={Profile} />
      <Route path={`${match.url}icon`} component={Icons} />
    </Switch>
  </Fragment>
);

export default App;
